/* @flow weak */
import React from 'react';
import cx from 'classnames';
import Image from 'components/Image.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';

import './styles/JoinAvatarPanel.scss';

const JoinOrganizationAvatarPanel = React.createClass({
  propTypes: {
    organization: React.PropTypes.instanceOf(OrganizationProfile).isRequired,
    title: React.PropTypes.string,
    /* show the school name below the title, default true */
    showSchoolNameAboveAvatar: React.PropTypes.bool,
    /* show the school name above the address, default false */
    showSchoolNameAboveAddress: React.PropTypes.bool,
    /* faded theme (greyed) */
    faded: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      showSchoolNameAboveAvatar: true,
      showSchoolNameAboveAddress: false,
    };
  },

  getSchoolImage() {
    // TODO return school image (not in entity ATM).
    return require('assets/images/school-circle.svg');
  },

  render() {
    const title = this.props.title ? this.props.title : 'Sign up for Remind at';
    let name = null;

    if (this.props.showSchoolNameAboveAvatar) {
      name = (
        <h4>
          <strong>
            {this.props.organization.getName()}
          </strong>
        </h4>
      );
    }

    let schoolName = null;
    if (this.props.showSchoolNameAboveAddress) {
      schoolName = (
        <span>
          <strong>
            {this.props.organization.getName()}
          </strong>
        </span>
      );
    }

    return (
      <div
        className={cx('JoinAvatarPanel', this.props.className, {
          'JoinAvatarPanel-Faded': this.props.faded,
        })}>
        <div className="JoinAvatarPanel-Header">
          <h4>{title}</h4>
          {name}
        </div>

        <Image className="JoinAvatarPanel-Image" src={this.getSchoolImage()} />

        <div className="JoinAvatarPanel-Footer">
          {schoolName}<br />

          {this.props.organization.getStreet() ?
            (<span>{this.props.organization.getStreet()}<br /></span>) : null
          }
          <span>
            {this.props.organization.getCity()}{', '}
            {this.props.organization.getState()}{' '}
            {this.props.organization.getZip()}
          </span>
        </div>
      </div>
    );
  },
});

export default JoinOrganizationAvatarPanel;



// WEBPACK FOOTER //
// ./src/join/components/JoinOrganizationAvatarPanel.jsx